import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

export const humidityElementConfig: SensorElementConfig<Record<string, never>, typeof SensorConversions.unity> = {
    legalConvertedRange: [0, 100],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "percent_rh",
    convertedUnits: "percent_rh",
    unitCategory: "humidity",
    testCases: [
        { parameters: {}, decodedValue: 60, convertedValue: 60 },
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
    ],
} as const;
